import type { AuthoredCard } from "../../../schemas"

/**
 * Basic Battle Bot — system starter card.
 * Each player starts with 5; not authored by players.
 * Stats: 1/1, no skills.
 */
export const BASIC_BATTLE_BOT_DEF: AuthoredCard = {
  id: "basic_battle_bot",
  kind: "starter",
  name: "Basic Battle Bot",
  primaryColor: "red",
  stats: { attack: 1, health: 1 },
  selectedSkills: [],
  authoredCostInputs: {
    skillCostDelta: 0,
    nonExhaustSurcharge: 0,
    selfDestructSurcharge: 0,
    secondaryColorSurcharge: 0,
  },
  derivedCost: 0,
}

/**
 * Spark Bot — system starter card.
 * Stats: 0/1, Spark skill (when played: gain 1 energy).
 */
export const SPARK_BOT_DEF: AuthoredCard = {
  id: "spark_bot",
  kind: "starter",
  name: "Spark Bot",
  primaryColor: "red",
  stats: { attack: 0, health: 1 },
  selectedSkills: [{ skillId: "spark" }],
  authoredCostInputs: {
    skillCostDelta: 0.5,
    nonExhaustSurcharge: 0,
    selfDestructSurcharge: 0,
    secondaryColorSurcharge: 0,
  },
  derivedCost: 1,
}

/**
 * Better Battle Bot — permanent fallback purchase lane.
 * Recruit cost: 2 energy. Stats: 3/2.
 * Has Scrap skill (self-destruct for small tactical value).
 */
export const BETTER_BATTLE_BOT_DEF: AuthoredCard = {
  id: "better_battle_bot",
  kind: "better_battle_bot",
  name: "Better Battle Bot",
  primaryColor: "red",
  stats: { attack: 3, health: 2 },
  selectedSkills: [{ skillId: "scrap" }],
  authoredCostInputs: {
    skillCostDelta: 0,
    nonExhaustSurcharge: 0,
    selfDestructSurcharge: 0,
    secondaryColorSurcharge: 0,
  },
  derivedCost: 2,
}

export const BETTER_BATTLE_BOT_RECRUIT_COST = 2
export const BASIC_BATTLE_BOTS_PER_PLAYER = 6
export const MERC_ROW_VISIBLE_SLOTS = 3
